import type { ReactElement } from 'react';
import type { Issue } from '@tallyframe/core';
import { describeIssueLocation, type IssueContext } from '../api/errors';

/**
 * The issues attached to an error, with where each one happened.
 *
 * An error that only says "rejected" costs somebody a support ticket. Core
 * collects every problem at once and locates each of them by row, column or
 * widget, and this is where that work becomes visible.
 *
 * All of this text originates in uploads and agent input, so it is rendered as
 * text nodes only.
 */
export function IssueList({
  issues,
  context
}: {
  issues: Issue[];
  context?: IssueContext;
}): ReactElement | null {
  if (issues.length === 0) return null;
  return (
    <ul className="m-0 pl-5 list-disc">
      {issues.map((issue, index) => {
        const where = describeIssueLocation(issue, context);
        return (
          <li key={`${issue.code}-${index}`}>
            {issue.message}
            {where ? <> <span className="text-muted">({where})</span></> : null}
          </li>
        );
      })}
    </ul>
  );
}
